import { z } from 'zod';

/**
 * Schema for customer group form data
 */
export const customerGroupSchema = z.object({
  ma_nhom: z.string().min(1, 'Mã nhóm là bắt buộc'),
  ten_phan_nhom: z.string().min(1, 'Tên nhóm là bắt buộc'),
  ten2: z.string().optional().nullable(),
  trang_thai: z.string().default('1')
});

export type CustomerGroupFormValues = z.infer<typeof customerGroupSchema>;

/**
 * Initial values for customer group form
 */
export const initialFormValues: CustomerGroupFormValues = {
  ma_nhom: '',
  ten_phan_nhom: '',
  ten2: '',
  trang_thai: '1'
};

/**
 * Schema for customer group detail
 */
export const customerGroupDetailSchema = z.object({
  ma_nhom: z.string().min(1, 'Mã nhóm là bắt buộc'),
  ten_phan_nhom: z.string().min(1, 'Tên phân nhóm là bắt buộc'),
  ten2: z.string().optional().nullable(),
  trang_thai: z.string().default('active')
});

export type CustomerGroupDetailFormValues = z.infer<typeof customerGroupDetailSchema>;

/**
 * Type for creating or updating a Group
 */
export interface GroupInput {
  /**
   * Group code
   */
  ma_nhom: string;

  /**
   * Group name
   */
  ten_phan_nhom: string;

  /**
   * Alternative group name (optional)
   */
  ten2?: string | null;

  /**
   * Group status ('0'=inactive, '1'=active)
   */
  trang_thai: string;

  /**
   * Group type (KH1=Customer1, KH2=Customer2, KH3=Customer3)
   */
  loai_nhom: string;
}
